<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <form
    class="retail-activity-report-container"
    [formGroup]="retailActivityForm"
  >
    <ion-row>
      <ion-col
        size="12"
      >
        <div class="form-group form-group-lg no-margin">
          <label class="date-label">{{ CONSTS.DATE_LABEL }} </label>
        </div>
        <app-form-date-picker
          formControlName="date"
          [customClass]="'report-date-picker'"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [icon]="IMAGES.CALENDAR"
        ></app-form-date-picker>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-download-note numRows="2,000"> </app-download-note>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>

<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="
    retailActivityReport && retailActivityReport.response.retailActivity
  "
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasSingleSubHeaderView]="false"
>
  @if (retailActivityReport && retailActivityReport.response) {
    <ng-container sub-header>
      <div class="pdf-sub-header-wrapper">
        <div class="pdf-sub-header-group">
          <h5>{{ PDF_REPORT.HEADER.LOCATION }}</h5>
          <h5 class="pdf-sub-header-value">
            {{ retailActivityReport.response.location }}
          </h5>
        </div>
        <div class="pdf-sub-header-group">
          <h5>{{ PDF_REPORT.HEADER.DATE }}</h5>
          <h5 class="pdf-sub-header-value">
            {{ retailActivityReport.response.date }}
          </h5>
        </div>
      </div>
    </ng-container>
  }
</app-pdf-report-generator>
